<!--
 * @Description: 膨胀剂模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:05:45
-->
<template>
  <div id="template8" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="9"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>车牌号</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td :class="{ bg4: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td>材质证明</td>
        <td :class="{ bg5: !isViewResult }">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td>外观及颜色</td>
        <td :class="{ bg5: !isViewResult }">
          <el-select v-model="formData.cell_18.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_18.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td colspan="2">啤酒瓶检测膨胀率</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>1.18mm筛余（%）</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_20.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>加水时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_21.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" @change="getChanges"> </el-date-picker>
        </td>
        <td>初凝测读时间</td>
        <td :class="{ bg6: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_22.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" @change="getChanges"> </el-date-picker>
        </td>
        <td>终凝测读时间</td>
        <td :class="{ bg6: !isViewResult }" class="select_date">
          <el-date-picker v-model="formData.cell_23.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" @change="getChanges"> </el-date-picker>
        </td>
        <td>胶砂加水时间</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="4">
          <el-date-picker v-model="formData.cell_24.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择" @change="getChanges"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td rowspan="2">标准稠度用水量检测</td>
        <td>试样重（g）</td>
        <td>试杆距底板距离（mm）</td>
        <td>用水量（ml）</td>
        <td>标准稠度用水量（%）</td>
        <td>初凝时间（min）</td>
        <td>终凝时间（min）</td>
        <td>试验期龄</td>
        <td colspan="2">7天</td>
        <td colspan="2">28天</td>
      </tr>
      <tr>
        <td class="bg4">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td class="bg4">
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_27.clsObj">
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg2: !isViewResult }">{{ formData.cell_28.resultValue }}</td>
        <td :class="formData.cell_29.clsObj">
          {{ formData.cell_29.resultValue }}
          <el-tooltip v-if="formData.cell_29.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_29.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="formData.cell_30.clsObj">
          {{ formData.cell_30.resultValue }}
          <el-tooltip v-if="formData.cell_30.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_30.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>强度项目</td>
        <td>检测值</td>
        <td>平均值</td>
        <td>检测值</td>
        <td>平均值</td>
      </tr>
      <tr>
        <td rowspan="2">限制膨胀率（%）</td>
        <td>水中7天</td>
        <td :class="formData.cell_31_p12.clsObj" colspan="2" @click="setData('cell_31')">{{ formData.cell_31_p12.resultValue || "请配置" }}</td>
        <td rowspan="2">比表面积（m²/kg）</td>
        <td :class="{ bg1: !isViewResult }" colspan="2" rowspan="2">
          <el-input v-model="formData.cell_33.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td rowspan="7">抗压强度</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_35.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_41.clsObj" rowspan="7">
          {{ formData.cell_41.resultValue }}
          <el-tooltip v-if="formData.cell_41.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_41.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_42.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_48.clsObj" rowspan="7">
          {{ formData.cell_48.resultValue }}
          <el-tooltip v-if="formData.cell_48.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_48.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td>空气中28天</td>
        <td :class="formData.cell_31_p13.clsObj" colspan="2" @click="setData('cell_32')">{{ formData.cell_31_p13.resultValue || "请配置" }}</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_36.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_43.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="4">备 注</td>
        <td rowspan="4" colspan="6">
          <el-input v-model="formData.cell_34.resultValue" type="textarea" :rows="4" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_37.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_44.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_38.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_45.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_39.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_40.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>

<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },

  cell_17: {
    resultValue: "",
    title: "材质证明",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_18: {
    resultValue: "",
    title: "外观及颜色",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_19: { resultValue: "", title: "啤酒瓶检测膨胀率", category: 7, type: 2 },
  cell_20: { resultValue: "", title: "1.18mm筛余（%）", category: 7, type: 2 },

  cell_21: { resultValue: "", key: "jssj", title: "加水时间", category: 3, type: 3, code: "cell_21" },
  cell_22: { resultValue: "", key: "cncdsj", title: "初凝测读时间", category: 3, type: 3, code: "cell_22" },
  cell_23: { resultValue: "", key: "zncdsj", title: "终凝测读时间", category: 3, type: 3, code: "cell_23" },
  cell_24: { resultValue: "", key: "jsjssj", title: "胶砂加水时间", category: 3, type: 3, code: "cell_24" },
  cell_25: { resultValue: "", key: "syz", title: "试样重", category: 3, type: 3, code: "cell_25", default: "500" },
  cell_26: { resultValue: "", key: "sgjdbjl", title: "试杆据底板距离", category: 3, type: 3, code: "cell_26", default: "6" },
  cell_27: { resultValue: "", key: "bzcdysl", title: "用水量", category: 3, type: 3, code: "cell_27" },

  cell_31_p01: { unit: "mm", valType: "input", resultValue: "", key: "jzcd7", title: "试体的基准长度", category: 3, type: 3, code: "cell_31_p01" },
  cell_31_p02: { unit: "mm", valType: "input", resultValue: "", key: "cscd7", title: "试体的初始长度测量值1", category: 3, type: 3, code: "cell_31_p02" },
  cell_31_p07: { unit: "mm", valType: "input", resultValue: "", key: "cscd7", title: "试体的初始长度测量值2", category: 3, type: 3, code: "cell_31_p07" },
  cell_31_p03: { unit: "mm", valType: "input", resultValue: "", key: "cd7_1", title: "水中7天长度1", category: 3, type: 3, code: "cell_31_p03" },
  cell_31_p05: { unit: "mm", valType: "calc", resultValue: "", key: "pzl7_1", title: "水中7天限制膨胀率1", category: 3, type: 3, code: "cell_31_p05" },
  cell_31_p08: { unit: "mm", valType: "input", resultValue: "", key: "cd7_2", title: "水中7天长度2", category: 3, type: 3, code: "cell_31_p08" },
  cell_31_p10: { unit: "mm", valType: "calc", resultValue: "", key: "pzl7_2", title: "水中7天限制膨胀率2", category: 3, type: 3, code: "cell_31_p10" },
  cell_31_p12: { unit: "mm", valType: "calc", resultValue: "", key: "xzpzl7", title: "限制膨胀率水中7天", category: 1, type: 3, code: "cell_31_p12", clsObj: { bg1: true } },

  //todo 重复
  // cell_31_p01:{resultValue: '', key: 'jzcd21', title: '试体的基准长度', category: 3, type: 3, code: 'cell_31_p01'},
  // cell_31_p02:{resultValue: '', key: 'cscd7', title: '试体的初始长度测量值1', category: 3, type: 3, code: 'cell_31_p02'},
  // cell_31_p07:{resultValue: '', key: 'cscd7', title: '试体的初始长度测量值2', category: 3, type: 3, code: 'cell_31_p07'},
  cell_31_p04: { unit: "mm", valType: "input", resultValue: "", key: "cd21_1", title: "空气中21天长度1", category: 3, type: 3, code: "cell_31_p04" },
  cell_31_p06: { unit: "", valType: "calc", resultValue: "", key: "pzl21_1", title: "空气中21天限制膨胀率1", category: 3, type: 3, code: "cell_31_p06" },
  cell_31_p09: { unit: "mm", valType: "input", resultValue: "", key: "cd21_2", title: "空气中21天长度2", category: 3, type: 3, code: "cell_31_p09" },
  cell_31_p11: { unit: "", valType: "calc", resultValue: "", key: "pzl21_2", title: "空气中21天限制膨胀率2", category: 3, type: 3, code: "cell_31_p11" },
  cell_31_p13: { unit: "", valType: "calc", resultValue: "", key: "xzpzl21", title: "限制膨胀率空气中21天", category: 1, type: 3, code: "cell_31_p13", clsObj: { bg1: true } },

  cell_33: { resultValue: "", key: "bbmj", title: "比表面积", category: 1, type: 3, code: "cell_33", clsObj: { bg1: true } },

  cell_34: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_34" },
  cell_35: { resultValue: "", key: "kyqd7_1", title: "7d抗压强度1", category: 6, type: 3, code: "cell_35" },
  cell_36: { resultValue: "", key: "kyqd7_2", title: "7d抗压强度2", category: 6, type: 3, code: "cell_36" },
  cell_37: { resultValue: "", key: "kyqd7_3", title: "7d抗压强度3", category: 6, type: 3, code: "cell_37" },
  cell_38: { resultValue: "", key: "kyqd7_4", title: "7d抗压强度4", category: 6, type: 3, code: "cell_38" },
  cell_39: { resultValue: "", key: "kyqd7_5", title: "7d抗压强度5", category: 6, type: 3, code: "cell_39" },
  cell_40: { resultValue: "", key: "kyqd7_6", title: "7d抗压强度6", category: 6, type: 3, code: "cell_40" },
  cell_42: { resultValue: "", key: "kyqd28_1", title: "28d抗压强度1", category: 6, type: 3, code: "cell_42" },
  cell_43: { resultValue: "", key: "kyqd28_2", title: "28d抗压强度2", category: 6, type: 3, code: "cell_43" },
  cell_44: { resultValue: "", key: "kyqd28_3", title: "28d抗压强度3", category: 6, type: 3, code: "cell_44" },
  cell_45: { resultValue: "", key: "kyqd28_4", title: "28d抗压强度4", category: 6, type: 3, code: "cell_45" },
  cell_46: { resultValue: "", key: "kyqd28_5", title: "28d抗压强度5", category: 6, type: 3, code: "cell_46" },
  cell_47: { resultValue: "", key: "kyqd28_6", title: "28d抗压强度6", category: 6, type: 3, code: "cell_47" },
  // 以下为计算属性
  cell_28: { resultValue: "", key: "bzcd", title: "标准稠度用水量", category: 1, type: 3, code: "cell_28", clsObj: { bg2: true } },
  cell_29: { resultValue: "", key: "cnsj", title: "初凝时间", category: 1, type: 3, code: "cell_29", clsObj: { bg2: true } },
  cell_30: { resultValue: "", key: "znsj", title: "终凝时间", category: 1, type: 3, code: "cell_30", clsObj: { bg2: true } },
  cell_41: { resultValue: "", key: "kyqd7", title: "抗压强度7天平均值", category: 1, type: 3, code: "cell_41", clsObj: { bg1: true } },
  cell_48: { resultValue: "", key: "kyqd28", title: "抗压强度28天平均值", category: 1, type: 3, code: "cell_48", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
  },
  mounted() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (!item) {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 标准稠度用水量
      if (this.hasValues([27])) {
        val = ((this.getFieldVal(27) / 500) * 100).toFixed(1);
      }
      this.setFieldVal(28, val);
      // 计算初凝时间和终凝时间
      this.calcTime(21, 22, 29);
      this.calcTime(21, 23, 30);
      // 计算平均值
      this.calcAverage([35, 36, 37, 38, 39, 40], 41);
      this.calcAverage([42, 43, 44, 45, 46, 47], 48);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算堆积密度值
    calcTime(x, y, z) {
      let res = "";
      if (this.hasValues([x, y])) {
        let v1 = this.getFieldVal(x, true);
        let v2 = this.getFieldVal(y, true);
        res = (new Date(v2).getTime() - new Date(v1).getTime()) / 1000 / 60;
        res = Math.round(res);
      }
      this.setFieldVal(z, res);
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(2);
      }
      this.setFieldVal(z, res);
    },

    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      switch (curKey) {
        case "cell_31":
          config.form["cell_31_p01"] = this.formData["cell_31_p01"];
          config.form["cell_31_p02"] = this.formData["cell_31_p02"];
          config.form["cell_31_p03"] = this.formData["cell_31_p03"];
          config.form["cell_31_p05"] = this.formData["cell_31_p05"];
          config.form["cell_31_p07"] = this.formData["cell_31_p07"];
          config.form["cell_31_p08"] = this.formData["cell_31_p08"];
          config.form["cell_31_p10"] = this.formData["cell_31_p10"];
          config.form["cell_31_p12"] = this.formData["cell_31_p12"];
          break;
        case "cell_32":
          config.form["cell_31_p01"] = this.formData["cell_31_p01"];
          config.form["cell_31_p02"] = this.formData["cell_31_p02"];
          config.form["cell_31_p04"] = this.formData["cell_31_p04"];
          config.form["cell_31_p06"] = this.formData["cell_31_p06"];
          config.form["cell_31_p07"] = this.formData["cell_31_p07"];
          config.form["cell_31_p09"] = this.formData["cell_31_p09"];
          config.form["cell_31_p11"] = this.formData["cell_31_p11"];
          config.form["cell_31_p13"] = this.formData["cell_31_p13"];
          break;
        default:
          for (let key in this.formData) {
            if (key.indexOf(curKey) >= 0) {
              config.form[key] = this.formData[key];
            }
          }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      let res1 = "";
      let res2 = "";
      switch (this.curKey) {
        case "cell_31":
          if (this.hasValues(form, ["31_p01", "31_p02", "31_p03"])) {
            res1 = (((this.getFieldVal("31_p03", false, form) - this.getFieldVal("31_p02", false, form)) / this.getFieldVal("31_p01", false, form)) * 100).toFixed(3);
            this.setFieldVal("31_p05", res1);
          }
          if (this.hasValues(form, ["31_p01", "31_p07", "31_p08"])) {
            res2 = (((this.getFieldVal("31_p08", false, form) - this.getFieldVal("31_p07", false, form)) / this.getFieldVal("31_p01", false, form)) * 100).toFixed(3);
            this.setFieldVal("31_p10", res2);
          }
          res = ((res1 * 1 + res2 * 1) / 2).toFixed(3);
          this.setFieldVal("31_p12", res);
          break;
        case "cell_32":
          if (this.hasValues(form, ["31_p01", "31_p02", "31_p04"])) {
            res1 = (((this.getFieldVal("31_p04", false, form) - this.getFieldVal("31_p02", false, form)) / this.getFieldVal("31_p01", false, form)) * 100).toFixed(3);
            this.setFieldVal("31_p06", res1);
          }
          if (this.hasValues(form, ["31_p01", "31_p07", "31_p09"])) {
            res2 = (((this.getFieldVal("31_p09", false, form) - this.getFieldVal("31_p07", false, form)) / this.getFieldVal("31_p01", false, form)) * 100).toFixed(3);
            this.setFieldVal("31_p11", res2);
          }
          res = ((res1 * 1 + res2 * 1) / 2).toFixed(3);
          this.setFieldVal("31_p13", res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
